<template>
    <el-tabs type="border-card" v-model="loanType" v-loading="loading">
        <!-- 公积金贷款 -->
        <el-tab-pane label="公积金贷款" name="2">
			<div class="load-card">
				<el-form :model="accumulationFund" :rules="rules" ref="ruleForm2" label-width="150px" class="demo-ruleForm">
				    <el-form-item label="贷款类型" prop="loanType">
				        <el-radio-group v-model="accumulationFund.loanType" size="small">
				            <el-radio-button label="20">等额本金</el-radio-button>
				            <el-radio-button label="10">等额本息</el-radio-button>
				        </el-radio-group>
				    </el-form-item>
				    <el-form-item label="贷款金额(万元)" prop="totalPrice">
				        <el-input v-model.number="accumulationFund.totalPrice" placeholder="请填写贷款金额(万元)"
				                  maxlength="6"></el-input>
				    </el-form-item>
				    <el-form-item label="期限(年)" prop="year">
				        <el-select v-model="accumulationFund.year" placeholder="请选择期限(年)" style="width: 100%;" @change="g_year_picker">
				            <el-option :label="g.label" :value="g.value" v-for="(g,gI) in accumulationFund.year_list" :key="gI"></el-option>
				        </el-select>
				    </el-form-item>
					<el-form-item label="房屋套数">
					    <el-select v-model="accumulationFund.house" placeholder="请选择房屋套数" style="width: 100%;" @change="g_year_picker">
					        <el-option :label="h.label" :value="h.value" v-for="(h,hI) in accumulationFund.house_list" :key="hI"></el-option>
					    </el-select>
					</el-form-item>
				    <el-form-item label="利率(%)" prop="interestRate">
						<el-input v-model="accumulationFund.interestRate" placeholder="请填写利率(%)"
						          maxlength="6" disabled></el-input>
				    </el-form-item>
				    <el-form-item>
				        <el-button type="primary" @click="g_submitCal('ruleForm2')" style="width: 100%">计算</el-button>
				    </el-form-item>
				</el-form>
				<el-card class="box-card">
					<div>
					    <div class="loan-rs">
					        <p>每月月供参考(元)：<p class="payment">{{accumulationFund.monthRepaymentAmount}}</p></p>
					    </div>
						<div class="loan-rs">
						    <p>支付利息(元)：<p class="payment">{{accumulationFund.repaymentSum}}</p></p>
						</div>
						<div class="loan-rs">
						    <p>还款总额(元)：<p class="payment">{{accumulationFund.repaymentRateSum}}</p></p>
						</div>
						<div class="loan-rs" v-show="gdce">
						    <p style="font-size: 13px;color: #999999;">等额本金还款较等额本息少{{accumulationFund.balance}}元利息</p>
						</div>
					</div>
				</el-card>
			</div>
			<div  v-show="gdce">
				<p style="font-size: 24px;padding: 10px 0;">还款计划</p>
				 <el-table
				
				    :data="accumulationFund.tableData"
				    height="400"
				    border
					v-loading="accumulationFund.tableloading"
				    style="width: 100%">
				    <el-table-column
				      prop="qs"
				      label="期数"
				      width="180">
				    </el-table-column>
				    <el-table-column
				      prop="yhbj"
				      label="应还本金"
				      width="180">
				    </el-table-column>
				    <el-table-column
				      prop="yhlx"
				      label="应还利息">
				    </el-table-column>
					<el-table-column
					  prop="yhke"
					  label="月还款额">
					</el-table-column>
					<el-table-column
					  prop="dkye"
					  label="贷款余额">
					</el-table-column>
				  </el-table>
			</div>
			
        </el-tab-pane>
        <!-- 组合贷款 -->
        <el-tab-pane label="组合贷款" name="3">
			<div  class="load-card">
				<el-form :model="combinationLoan" :rules="rulesThree" ref="ruleForm3" label-width="160px"
				         class="demo-ruleForm">
				    <el-form-item label="贷款类型" prop="loanType">
				        <el-radio-group v-model="combinationLoan.loanType" size="small">
				            <el-radio-button label="20">等额本金</el-radio-button>
				            <el-radio-button label="10">等额本息</el-radio-button>
				        </el-radio-group>
				    </el-form-item>
				    <el-form-item label="商贷贷款金额(万元)" prop="zhs_Price">
				        <el-input v-model.number="combinationLoan.zhs_Price" placeholder="请填写商贷贷款金额(万元)"
				                  maxlength="6"></el-input>
				    </el-form-item>
				    <el-form-item label="商贷利率(%)" prop="zhs_interestRate">
						<el-input v-model="combinationLoan.zhs_interestRate" placeholder="请填写利率(%)"
						          maxlength="6" disabled></el-input>
				    </el-form-item>
				    <el-form-item label="公积金贷款金额(万元)" prop="zhg_Price">
				        <el-input v-model.number="combinationLoan.zhg_Price" placeholder="请填写公积金贷款金额(万元)"
				                  maxlength="6"></el-input>
				    </el-form-item>
				    <el-form-item label="公积金利率(%)" prop="zhg_interestRate">
						<el-input v-model="combinationLoan.zhg_interestRate" placeholder="请填写利率(%)"
						          maxlength="6" disabled></el-input>
				    </el-form-item>
				
				    <el-form-item label="期限(年)" required>
				        <el-select v-model="combinationLoan.year" placeholder="请选择期限(年)" style="width: 100%;" @change="zh_year_picker">
				            <el-option :label="g.label" :value="g.value" v-for="(g,gI) in combinationLoan.year_list" :key="gI"></el-option>
				        </el-select>
				    </el-form-item>
					<el-form-item label="房屋套数">
					    <el-select v-model="combinationLoan.house" placeholder="请选择房屋套数" style="width: 100%;" @change="zh_year_picker">
					        <el-option :label="h.label" :value="h.value" v-for="(h,hI) in combinationLoan.house_list" :key="hI"></el-option>
					    </el-select>
					</el-form-item>
				    <el-form-item>
				        <el-button type="primary" @click="zh_submitCal('ruleForm3')" style="width: 100%">计算</el-button>
				    </el-form-item>
				</el-form>
				
				<el-card class="box-card">
					<div>
					    <div class="loan-rs">
					        <p>公贷月还款额(元)：<p class="payment">{{combinationLoan.g_monthRepaymentAmount}}</p></p>
					    </div>
						<div class="loan-rs">
						    <p>公贷应还利息总额(元)：<p class="payment">{{combinationLoan.g_repaymentSum}}</p></p>
						</div>
						<div class="loan-rs">
						    <p>公贷还款总额(元)：<p class="payment">{{combinationLoan.g_repaymentRateSum}}</p></p>
						</div>
						<div class="loan-rs">
						    <p>商贷月还款额(元)：<p class="payment">{{combinationLoan.s_monthRepaymentAmount}}</p></p>
						</div>
						<div class="loan-rs">
						    <p>商贷应还利息总额(元)：<p class="payment">{{combinationLoan.s_repaymentSum}}</p></p>
						</div>
						<div class="loan-rs">
						    <p>商贷还款总额(元)：<p class="payment">{{combinationLoan.s_repaymentRateSum}}</p></p>
						</div>
						<div class="loan-rs" v-show="zhce">
						    <p style="font-size: 13px;color: #999999;">等额本金还款较等额本息少{{combinationLoan.balance}}元利息</p>
						</div>
					</div>
				</el-card>
			</div>
            <div  v-show="zhce">
            	<p style="font-size: 24px;padding: 10px 0;">还款计划</p>
            	 <el-table
            	    :data="combinationLoan.tableData"
            	    height="400"
            	    border
					v-loading="combinationLoan.tableloading"
            	    style="width: 100%">
            	    <el-table-column
            	      prop="qs"
            	      label="期数"
            	      width="180">
            	    </el-table-column>
            	    <el-table-column
            	      prop="yhbj"
            	      label="应还本金"
            	      width="180">
            	    </el-table-column>
            	    <el-table-column
            	      prop="yhlx"
            	      label="应还利息">
            	    </el-table-column>
            		<el-table-column
            		  prop="yhke"
            		  label="月还款额">
            		</el-table-column>
            		<el-table-column
            		  prop="dkye"
            		  label="贷款余额">
            		</el-table-column>
            	  </el-table>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>

<script type="text/babel">
    import Vue from 'vue'
    import * as CFHL from '../assets/js/jisuan.js';
	import axios from "axios";
	import qs from 'qs';

    export default Vue.component('Loan', {
        data() {
            const totalPrice = (rule, value, callback) => { // 判断手机号是否正确
                if (value) {
                    value = parseInt(value);
                    let regTest = /^0/
                    if (regTest.test(value) || isNaN(value)) {
                        callback(new Error('请输入正整数'))
                    } else {
                        if (value * 1 > 200000) {
                            // value = 200000;
                            callback(new Error('请不要输入超过200000万元'))
                        } else {
                            callback();
                        }
                    }
                } else {
                    callback(new Error('请输入贷款金额'));
                }
            };

            return {
                loanType: '2',
				loading:true,
				gdce:false,
				zhce:false,
                accumulationFund: {
                    monthRepaymentAmount: 0,//月供
                    repaymentSum: 0,//总利息
                    repaymentRateSum: 0,//还款总额
                    totalPrice: '',//贷款金额
					house:1,//房屋套数
					house_list:[
						{value:1,label:'首套'},
						{value:2,label:'二套'}
					],
                    loanType: '20',//公积金贷款类型 10等额本息 20等额本金
                    year: 20,//公积金期限
                    year_list: [],//公积金期限列表
                    interestRate: '',//公积金默认利率
					balance:'',//两种方式还款总额差额
					tableData: [],//还款计划
					tableloading:true,
                },
                combinationLoan: {
                    g_monthRepaymentAmount: 0,//公积金月供
                    g_repaymentSum: 0,//公积金总利息
                    g_repaymentRateSum: 0,//公积金还款总额
					s_monthRepaymentAmount: 0,//商贷月供
					s_repaymentSum: 0,//商贷总利息
					s_repaymentRateSum: 0,//商贷还款总额
                    zhs_Price: '',//商贷金额
                    zhg_Price: '',//公贷金额
                    loanType: '20',//组合贷贷款类型 10等额本息 20等额本金
                    year: 20,//组合期限
                    year_list: [],//组合期限列表
					house:1,//房屋套数
					house_list:[
						{value:1,label:'首套'},
						{value:2,label:'二套'}
					],
                    zhs_interestRate: '',//组合商贷款利率
                    zhg_interestRate: '',//组合商贷公积金贷款利率
					balance:'',//两种方式还款总额差额
					tableData: [],//还款计划
					tableloading:true,
                },
                rules: {
                    totalPrice: [
                        {required: true, message: '请输入贷款金额', trigger: 'blur'},
                        {validator: totalPrice, trigger: 'blur'},
                    ],
                    year: [
                        {required: true, message: '请选择期限', trigger: 'change'}
                    ],
                    interestRate: [
                        {required: true, message: '请填写利率', trigger: 'change'}
                    ],
                },
                rulesThree: {
                    zhs_Price: [
                        {required: true, message: '请输入贷款金额', trigger: 'blur'},
                        {validator: totalPrice, trigger: 'blur'},
                    ],
                    zhg_Price: [
                        {required: true, message: '请输入贷款金额', trigger: 'blur'},
                        {validator: totalPrice, trigger: 'blur'},
                    ],
                    year: [
                        {required: true, message: '请选择期限', trigger: 'change'}
                    ],
                    zhs_interestRate: [
                        {required: true, message: '请填写商贷利率', trigger: 'change'}
                    ],
                    zhg_interestRate: [
                        {required: true, message: '请填写公积金利率', trigger: 'change'}
                    ],
                }
            }
        },
        mounted() {
            this.initYearList();
			this.getinterestRate('20');
        },
        methods: {
            initYearList() {
                let yearList = [];
                for (var i = 1; i <= 30; i++) {
					let year ={value:i,label:i+'年'+i*12+'期'}
                    yearList.push(year);
                }
                this.accumulationFund.year_list = yearList;
                this.combinationLoan.year_list = yearList;
            },
			// 获取默认20年利率
			getinterestRate(){
				axios.post("/token/admin/huaxin/index",qs.stringify({
					data:{"buzType":"5329","loanhousenum":"1","loanterm":20*12},
					url:"business/appapi700036.json"
				}))
				.then(response => {
					this.accumulationFund.interestRate = parseFloat(response.data.loanrate).toString()
					this.combinationLoan.zhg_interestRate = parseFloat(response.data.loanrate).toString()
					this.combinationLoan.zhs_interestRate = parseFloat(response.data.rate).toString()
					this.loading=false
				})
			    .catch(function(error) {
					// 请求失败处理
					console.log(error);
			    });
				  
			},
			// 公积金贷款切换年份查询利率
			g_year_picker() {
				this.loading=true
			    axios.post("/token/admin/huaxin/index",qs.stringify({
			    	data:{"buzType":"5329","loanhousenum":this.accumulationFund.house,"loanterm":this.accumulationFund.year*12},
			    	url:"business/appapi700036.json"
			    }))
			    .then(response => {
			    	this.accumulationFund.interestRate = parseFloat(response.data.loanrate).toString()
			    	this.loading=false
			    })
			    .catch(function(error) {
			    	// 请求失败处理
			    	console.log(error);
			    });
			    
			},
			// 组合贷款切换年份查询利率
			zh_year_picker(loanterm){
				this.loading=true
				axios.post("/token/admin/huaxin/index",qs.stringify({
					data:{"buzType":"5329","loanhousenum":this.combinationLoan.house,"loanterm":this.combinationLoan.year*12},
					url:"business/appapi700036.json"
				}))
				.then(response => {
					console.log(response.data)
					this.combinationLoan.zhg_interestRate = parseFloat(response.data.loanrate).toString()
					this.combinationLoan.zhs_interestRate = parseFloat(response.data.rate).toString()
					this.loading=false
				})
				.catch(function(error) {
					// 请求失败处理
					console.log(error);
				});
			},
			// 公积金贷款计算
			g_submitCal(formName){
				let that = this;
				this.$refs[formName].validate((valid) => {
				    if (valid) {
						that.loading=true
						that.accumulationFund.tableloading=true
				        axios.post("/token/admin/huaxin/index",qs.stringify({
				        	data:{"buzType":"5082","surplusLoanAmount":that.accumulationFund.totalPrice*10000,"commercialLoanAmount":"0",
				        	"loanDuration":that.accumulationFund.year,"surplusLoanInterestRate":that.accumulationFund.interestRate,
				        	"commercialLoanInterestRate":"0","repaymentType":that.accumulationFund.loanType},
				        	url:"appapi00901.json"
				        }))
				        .then(response => {
							that.accumulationFund.monthRepaymentAmount=response.data.result.monthRepaymentAmount
							that.accumulationFund.repaymentSum=response.data.result.repaymentSum
							that.accumulationFund.repaymentRateSum=response.data.result.repaymentRateSum
							that.accumulationFund.balance=response.data.result.balance
							that.gdce=true
							that.loading=false
							// 还款计划
							axios.post("/token/admin/huaxin/index",qs.stringify({
								data:{"buzType":"5082","surplusLoanAmount":that.accumulationFund.totalPrice*10000,
								"loanDuration":that.accumulationFund.year,"surplusLoanInterestRate":that.accumulationFund.interestRate,
								"repaymentType":that.accumulationFund.loanType},
								url:"appapi00903.json"
							}))
							.then(response => {
								that.accumulationFund.tableData=[];
								for(let i=0;i<response.data.result.length;i++){
									const data = {
										qs:response.data.result[i][0].info,
										yhbj:response.data.result[i][1].info,
										yhlx:response.data.result[i][2].info,
										yhke:response.data.result[i][3].info,
										dkye:response.data.result[i][4].info,
									}
									that.accumulationFund.tableData.push(data)
								}
								that.accumulationFund.tableloading=false
							})
							.catch(function(error) {
								// 请求失败处理
								console.log(error);
							});
							
				        })
				        .catch(function(error) {
				        	// 请求失败处理
				        	console.log(error);
				        });
						
				    } else {
				        return false;
				    }
				});
				
			},
			// 组合贷款计算
			zh_submitCal(formName){
				let that = this;
				this.$refs[formName].validate((valid) => {
				    if (valid) {
						that.loading=true
						that.combinationLoan.tableloading=true
				        axios.post("/token/admin/huaxin/index",qs.stringify({
				        	data:{"buzType":"5082","surplusLoanAmount":that.combinationLoan.zhg_Price*10000,
							"commercialLoanAmount":that.combinationLoan.zhs_Price*10000,
				        	"loanDuration":that.combinationLoan.year,"surplusLoanInterestRate":that.combinationLoan.zhg_interestRate,
				        	"commercialLoanInterestRate":that.combinationLoan.zhs_interestRate,"repaymentType":that.combinationLoan.loanType},
				        	url:"appapi00901.json"
				        }))
				        .then(response => {
							that.combinationLoan.g_monthRepaymentAmount=response.data.result.monthRepaymentAmount
							that.combinationLoan.g_repaymentSum=response.data.result.repaymentSum
							that.combinationLoan.g_repaymentRateSum=response.data.result.repaymentRateSum
							that.combinationLoan.s_monthRepaymentAmount=response.data.result.sdmonthRepaymentAmount
							that.combinationLoan.s_repaymentSum=response.data.result.sdrepaymentSum
							that.combinationLoan.s_repaymentRateSum=response.data.result.sdrepaymentRateSum
							that.combinationLoan.balance=response.data.result.balance
							that.loading=false
							that.zhce=true
							//还款计划
							axios.post("/token/admin/huaxin/index",qs.stringify({
								data:{"buzType":"5082","surplusLoanAmount":that.combinationLoan.zhg_Price*10000,
								"loanDuration":that.combinationLoan.year,"surplusLoanInterestRate":that.combinationLoan.zhg_interestRate,
								"repaymentType":that.combinationLoan.loanType},
								url:"appapi00903.json"
							}))
							.then(response => {
								that.combinationLoan.tableData=[];
								for(let i=0;i<response.data.result.length;i++){
									const data = {
										qs:response.data.result[i][0].info,
										yhbj:response.data.result[i][1].info,
										yhlx:response.data.result[i][2].info,
										yhke:response.data.result[i][3].info,
										dkye:response.data.result[i][4].info,
									}
									that.combinationLoan.tableData.push(data)
								}
								that.combinationLoan.tableloading=false
							})
							.catch(function(error) {
								// 请求失败处理
								console.log(error);
							});
							
				        })
				        .catch(function(error) {
				        	// 请求失败处理
				        	console.log(error);
				        });
				    } else {
				        return false;
				    }
				});
			},
        }
    })
</script>

<style scoped>

    .load-card {
        display: flex;
        justify-content: space-around;
    }

    .flex-between {
        display: flex;
        justify-content: space-between;
    }

    .loan-rs {
        padding: 20px;
        min-width: 280px;
        font-size: 14px;
		display: flex;
		align-items: center;
	}
	.payment {
		font-size: 18px;
		font-weight: bold;
	}
	/deep/.el-input.is-disabled .el-input__inner{
		background-color: #FFF;
		color: #606266;
	}
</style>
